<!-- start banner Area -->
<section class="top-banner">
  <div class="top-banner-img" style="">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 style="padding: 30px 0px 30px 0px !important; text-align: center; font-size: 65px !important;"> CV thèque
            (Tous les consultants)</h1>

          <div class="row  justify-content-center mb-5">
            <div class="col-lg-9">
              <div id="searchOtherBlock" style="display: " class="row justify-content-center mb-1 p-2">
                <div class="mb-3 col-md-4 col-lg-4 form-cols" id="default-selects2">
                  <select class="form-control" [(ngModel)]="produits" style="height: 50px !important;">
                    <option value="">RECHERCHER PAR PRODUITS...</option>
                    <option value="{{ produit.getId() }}" *ngFor="let produit of produitList">{{
                      produit.getLibelle() }}</option>
                  </select>
                </div>
                <div class="mb-3 col-md-4 col-lg-4 form-cols" id="">
                  <div class="default-select" id="default-selects2">
                    <select class="form-control" [(ngModel)]="expertises" style="height: 50px !important;">
                      <option value="">RECHERCHER PAR EXPERTISES...</option>
                      <option value="{{ expertise.getId() }}" *ngFor="let expertise of expertiseList">{{
                        expertise.getLibelle() }}</option>
                    </select>
                  </div>
                </div>
                <div class="mb-3 col-md-4 col-lg-4 form-cols">
                  <div class="default-select" id="default-selects2" style="height: 50px !important;">
                    <select class="form-control" [(ngModel)]="country" style="height: 50px !important;">
                      <option value="">RECHERCHER PAR PAYS...</option>
                      <option value="{{ country }}" *ngFor="let country of countryList">{{
                        country }}</option>
                    </select>
                  </div>
                </div>
                <!-- Second search row -->

                <div class="col-lg-4 form-cols">
                  <div class="default-select" id="default-selects2">
                    <select class="form-control" id="daily_fee" [(ngModel)]="daily_fee"
                      style="height: 50px !important;">
                      <option value="">RECHERCHER PAR HONORAIRE JOURNALIER...</option>
                      <option value="15 000 à 30 000">15 000 à 30 000</option>
                      <option value="31 000 à 50 000">31 000 à 50 000</option>
                      <option value="51 000 à 80 000">51 000 à 80 000</option>
                      <option value="81 000 à 100 000">81 000 à 100 000</option>
                      <option value="101 000 à 150 000">101 000 à 150 000</option>
                      <option value="151 000 à 200 000">151 000 à 200 000</option>
                      <option value="201 000 à 250 000">201 000 à 250 000</option>
                      <option value="251 000 à 300 000">251 000 à 300 000</option>
                      <option value="Plus de 300 000">Plus de 300 000</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4 form-cols">
                  <div class="default-select" id="default-selects">
                    <select class="form-control" [(ngModel)]="nb_mission" style="height: 50px !important;">
                      <option value="">RECHERCHER PAR NOMBRE DE MISSION...</option>
                      <option value="1 à 2">1 à 2</option>
                      <option value="3 à 5">3 à 5</option>
                      <option value="6 à 10">6 à 10</option>
                      <option value="Plus de 10">Plus de 10</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4 form-cols">
                  <div class="default-select" id="default-selects2">
                    <button type="button" (click)="searchConsultants()" style="height: 50px !important;"
                      class="btn btn-submit">Rechercher</button>
                  </div>
                </div>

              </div>



            </div>
          </div>
          <p class="text-white link-nav"><a [routerLink]="['/admin']" style="color: #ff5a00 !important">Accueil </a>
            <span class="lnr lnr-arrow-right"></span>

            <span class="lnr lnr-arrow-right"></span> <a routerLink="/tous-les-consultants" style="color: white;"> CV
              thèque (Tous les
              consultants)</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- End banner Area -->

<!-- Start post Area -->

<section class="post-area section-gap">
  <div class="container">

    <!-- Loading -->
    <div class="row d-flex justify-content-center mt-4 mb-4" *ngIf="isLoading">
      <span style="color: red">Chargement...</span>
    </div>
    <br>

    <!-- Button to export data -->
    <div class=" mb-4">
      <button class="btn btn-danger" style="float: right;" (click)="exportToExcel()">Exporter Excel</button>
    </div>


    <!-- Nb record find -->
    <div class="row d-flex justify-content-center mb-4">
      <span style="color: green">{{ consultantsList.length }} enregistrement (s) trouvé(s)</span>
    </div>

    <!-- Nb record selected -->
    <div class="row d-flex justify-content-center mb-4" *ngIf="consultantSelected.length > 0">
      <span style="color: red">{{ consultantSelected.length }} enregistrement (s) selectionné(s)</span>
    </div>

    <!-- Datatable -->
    <div class="row justify-content-center d-flex" style="width: 100%; overflow: auto; max-height: 655px;">
      <div class="col-lg-12 post-list mb-5">
        <table class="table table-striped table-bordered nowrap" style="width:100%">
          <thead>
            <tr>
              <th><input id="checkbox_all" type="checkbox" (click)="selectedRow('all', 'checkbox')"></th>
              <th>Nom & prénom</th>
              <th>Sexe</th>
              <th>Age</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Honoraire journ.</th>
              <th>Nbre de mission</th>
              <th>Dossier</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let consultants of consultantsList" (click)="selectedRow(consultants.getId(), 'row')">
              <td><input id="checkbox_{{ consultants.getId() }}" type="checkbox" disabled></td>
              <td>{{ consultants.getFirstName() }} {{ consultants.getLastName() }}</td>
              <td>{{ consultants.getGender() }}</td>
              <td>{{ calculateAge(consultants.getDateBirth()) }} ans</td>
              <td>{{ consultants.getEmail() }}</td>
              <td>{{ consultants.getPhone1() }} / {{ consultants.getPhone2() }}</td>
              <td>{{ consultants.getDailyFee() }}</td>
              <td>{{ consultants.getNbMission() }}</td>
              <td><button class="btn btn-info" (click)="getConsultantProfile(consultants.getId())">Voir</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
<!-- End post Area -->